export default "__VITE_PUBLIC_ASSET__9db2ee44__"